import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=7ceb3867&scoped=true"
import script from "./nutrition.vue?vue&type=script&lang=js"
export * from "./nutrition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb3867",
  null
  
)

export default component.exports